import { create } from "zustand";

const useUserSession = create((set) => ({
  isAuthenticated: null,
  userData: {},

  setIsAuthenticated: (authenticated) =>
    set((state) => ({
      ...state,
      isAuthenticated: authenticated,
    })),

  setUserData: (data) =>
    set((state) => ({
      ...state,
      userData: data,
    })),
}));

export default useUserSession;
